
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/property",
      function () {
        return require("private-next-pages/property.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/property"])
      });
    }
  